import { createContext, useContext } from 'react'

// The network/view the shell currently considers selected — the resolved
// sticky selection AppShell already computes for the breadcrumb (URL value
// when on a network route, else the last-visited values from localStorage).
//
// Exposed so routes rendered as AppShell `children` that have no networkId
// in their own URL (notably the full-page assistant at `/assistant`) can
// read what the researcher has selected without re-deriving it. Both are
// `undefined` when nothing is selected.
export type ShellSelection = {
  networkId: string | undefined
  viewId: string | undefined
}

const ShellSelectionContext = createContext<ShellSelection>({
  networkId: undefined,
  viewId: undefined,
})

export const ShellSelectionProvider = ShellSelectionContext.Provider

export function useShellSelection(): ShellSelection {
  return useContext(ShellSelectionContext)
}
